export const ANIM_SPEED_SHORT = 300;
export const ANIM_SPEED = 400;
export const ANIM_SPEED_LONG = 500;
